"use client";

import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Link } from "@/components/common/Link";
import { Minus, Plus } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const faqs = [{
  question: "How do I place a wholesale order?",
  answer: "Wholesale orders can be placed directly through our B2B portal or by contacting our Swan Hill office. We specialize in bulk supply for large-scale construction and infrastructure projects across Australia."
}, {
  question: "What are your primary delivery areas?",
  answer: "We provide reliable, heavy-duty delivery services throughout Victoria and across Australia. Our logistics network is optimized to ensure your materials arrive on-site and on-schedule, regardless of volume."
}, {
  question: "Are all materials compliant with Australian Standards?",
  answer: "Absolutely. Every product we supply—from structural steel to cement—undergoes rigorous quality control and is fully compliant with relevant Australian Building Standards to ensure project safety."
}, {
  question: "Do you offer credit accounts for trade partners?",
  answer: "Yes, we offer flexible credit terms for established commercial clients and registered contractors. Please contact our finance department to begin the application process for a trade account."
}, {
  question: "Can I request a custom quote for bulk supplies?",
  answer: "Certainly. We provide detailed, competitive quotes tailored to your project's specific material requirements and volume needs. Our team typically responds to quote requests within 24 to 48 hours."
}, {
  question: "What is the typical lead time for site delivery?",
  answer: "Lead times vary by product category, but most standard inventory items are available for immediate dispatch. For specialized bulk orders, we coordinate delivery within 3-5 business days for regional areas."
}];
export default function CommonQuestions() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="25160" id="common-procurement-queries" className="bg-card py-24 sm:py-32 border-y border-border">
      <div ref={ref} className={`mx-auto max-w-3xl px-6 lg:px-8 transition-all duration-700 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="mx-auto max-w-2xl text-center mb-16">
          <h2 className="text-3xl font-bold tracking-tight text-foreground sm:text-4xl font-serif uppercase">
            Common Procurement Queries
          </h2>
          <p className="mt-4 text-lg leading-8 text-muted-foreground font-sans">
            Essential information regarding bulk orders, logistics, and compliance for Australian contractors.
          </p>
        </div>

        <Accordion type="single" collapsible className="w-full">
          {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i} className="border-border">
              <AccordionTrigger className="group [&>svg:last-child]:hidden py-6 hover:no-underline hover:bg-muted/30 px-4 rounded-md transition-colors">
                <span className="text-base font-bold font-sans text-foreground text-left pr-4 tracking-tight">
                  {faq.question}
                </span>
                <span className="relative flex items-center justify-center size-5 shrink-0 text-primary">
                  <Plus className="absolute size-5 transition-transform duration-300 group-data-[state=open]:rotate-90 group-data-[state=open]:opacity-0" />
                  <Minus className="absolute size-5 transition-transform duration-300 rotate-90 opacity-0 group-data-[state=open]:rotate-0 group-data-[state=open]:opacity-100" />
                </span>
              </AccordionTrigger>
              <AccordionContent className="px-4 pb-6">
                <p className="text-base leading-7 text-muted-foreground font-sans">
                  {faq.answer}
                </p>
              </AccordionContent>
            </AccordionItem>)}
        </Accordion>

        <div className="mt-16 text-center">
          <p className="text-base text-muted-foreground font-sans">
            Still have technical questions?{" "}
            <Link to="/ContactPage" className="font-bold text-primary hover:text-primary/80 transition-colors uppercase tracking-wider text-sm">
              Contact our procurement team
            </Link>
          </p>
        </div>
      </div>
    </section>;
}